
import store from '../store'

const TravellerPrivileges = {
    install(Vue) {
        Vue.prototype.$hasPriviledge = function( privilege ) {
            return store.getters.userPrivileges.includes( privilege)
        }

        Vue.prototype.$UIPrivilege = function( path, view, action ) {
            if(path.includes("/")){
                action = view;
                view = null;
            }

            var privilege = "[UI] /" + path
            if(view) privilege += "/" + view;
            if(action) privilege += " [" + action + "]";

            //console.log(privilege);
            return store.getters.userPrivileges.includes( privilege)
        }

        Vue.prototype.$UIPrivilegeC = function(path, view){
            return this.$UIPrivilegeCreate(path, view)
        }

        Vue.prototype.$UIPrivilegeCreate = function(path, view) {
            var p = parsePath(path, view);
            return this.$UIPrivilege(p.path, p.view, "create")
        }

        Vue.prototype.$UIPrivilegeU = function(path, view){
            return this.$UIPrivilegeUpdate(path, view)
        }

        Vue.prototype.$UIPrivilegeUpdate = function(path, view) {
            var p = parsePath(path, view);
            return this.$UIPrivilege(p.path, p.view, "update")
        }

        Vue.prototype.$UIPrivilegeD = function(path, view){
            return this.$UIPrivilegeDelete(path, view)
        }

        Vue.prototype.$UIPrivilegeDelete = function(path, view) {
            var p = parsePath(path, view);
            return this.$UIPrivilege(p.path, p.view, "delete")
        }


        function parsePath(path, view){
            var p =  {};
            p.path = path;
            p.view = view;
            if(!view && path.includes("/")){
                var arr = path.split("/");
                var index = path.startsWith("/") ? 1 : 0
                p.path = arr[index];
                p.view = arr[index+1];
            }

            return p;
        }
       
    }
}

export default TravellerPrivileges
